import { forwardRef } from 'react';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import Text16 from '@sdk/components/ui/typography/Text16';
import Row from '@sdk/components/ui/spacing/Row';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import type { PremiumGuardPassedConfig } from '../../premiumGuard/PremiumGuard';
import PremiumGuardLabel from '../../premiumGuard/PremiumGuardLabel';

import SettingsSection from './SettingsSection';

type Props = {
  title: string;
  withSeparator?: boolean;
  premiumGuard?: PremiumGuardPassedConfig;
  opacity?: number;
};

// add premium label: timeclock screen business
const SettingsHeader = (
  { withSeparator, title, premiumGuard, opacity, ...props }: Props,
  ref
): JSX.Element => {
  return (
    <div ref={ref}>
      <SettingsSection pTop={20} {...props}>
        <Row>
          <Text16 semiBold themeColor={ThemeColorType.primary} opacity={opacity}>
            {title}
          </Text16>
          {premiumGuard && !premiumGuard.hasAccess && (
            <PremiumGuardLabel
              pLeft={10}
              label={premiumGuard.requiredPlan}
              tooltipId={premiumGuard.tooltipId}
              tooltipText={premiumGuard.tooltipContent}
            />
          )}
        </Row>
        {withSeparator && (
          <Row top={10} bottom={20}>
            <HorizontalSeparator />
          </Row>
        )}
      </SettingsSection>
    </div>
  );
};

export default forwardRef(SettingsHeader);
